import { ValidateLoginComponent } from './auth/validateLogin/validatelogin.component';
import { ValidateSignUpComponent } from './auth/validateSignUp/validateSignUp.component';
import { SignupComponent } from './auth/signup/signup.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from "./auth/logout/logout.component";
import { EmailVerifyComponent } from './core/pages/admin/emailVerify/emailVerify.component';
import { ConsumerSlabRateMasterComponent } from './core/pages/admin/Master/b2c-rate-approval/consumer-slab-rate-approval.component';

const routes: Routes = [
    { path: 'login', loadChildren: './auth/auth.module#AuthModule' },
    { path: 'login/wsfx', loadChildren: './auth/auth.module#AuthModule' },

    { path: 'logout', component: LogoutComponent },
    { path: 'signup', component: SignupComponent },
    { path: '', redirectTo: 'quick', pathMatch: 'full' },
    { path: 'validateLogin/:page', component: ValidateLoginComponent },
    { path: 'validateSignUp/:page', component: ValidateSignUpComponent },
    {
        path: "mailVerify",
        component: EmailVerifyComponent
    },
    {
        path: "consumerRateRuleSlabRequest/:requestType/:requestId",
        component: ConsumerSlabRateMasterComponent
    }


];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts